const bmRoutes = [
    {
        path: '/bms',
        name: 'bms',
        component: () => import('@/views/bm/BMs'),
    },
    {
        path: '/bms/create',
        name: 'bmCreate',
        component: () => import('@/views/bm/BMEdit'),
    },
    {
        path: '/bms/:id',
        name: 'bm',
        component: () => import('@/views/bm/BM'),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: '/bms/:id/edit',
        name: 'bmEdit',
        component: () => import('@/views/bm/BMEdit'),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: '/bms/:id/cashFlow',
        name: 'bmCashFlow',
        component: () => import('@/views/bm/BMCashFlow.vue'),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
]

export default bmRoutes